function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Pie Chart"));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "iconic-size-md-pie-chart-clip-0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 0l.042 19-13.042 13h26v-32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "iconic-size-md-pie-chart-clip-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 8l3-1 11.958 11.958-12.958 13.042h-2z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "iconic-size-md-pie-chart-clip-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 0h-14l2 4 11.999 12z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 32
}, /*#__PURE__*/React.createElement("circle", {
  clipPath: "url(#iconic-size-md-pie-chart-clip-0)",
  cx: 17.5,
  cy: 17.5,
  r: 14.5,
  className: "iconic-pie-chart-slice iconic-pie-chart-slice-large iconic-property-fill"
}), /*#__PURE__*/React.createElement("circle", {
  clipPath: "url(#iconic-size-md-pie-chart-clip-1)",
  cx: 12,
  cy: 18,
  r: 12,
  className: "iconic-pie-chart-slice iconic-pie-chart-slice-medium iconic-property-fill"
}), /*#__PURE__*/React.createElement("circle", {
  clipPath: "url(#iconic-size-md-pie-chart-clip-2)",
  cx: 14,
  cy: 14,
  r: 14,
  className: "iconic-pie-chart-slice iconic-pie-chart-slice-small iconic-property-fill"
}));

function SvgPieChartMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "pie-chart",
    className: "iconic iconic-pie-chart iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartMd);
export default __webpack_public_path__ + "static/media/pie-chart-md.ac15e6d6.svg";
export { ForwardRef as ReactComponent };